import { ErrorPage, Layout, Loader, NapovedaPage, OpenDataPage, OsobniUdajePage, PristupnostPage, useAuthorization, useConfig, useToken } from 'common';
import React, { Suspense, useEffect, useRef } from 'react';
import { Route, Switch } from 'react-router-dom';
import MainMenu from './components/MainMenu';

const Home = React.lazy(() => import('./pages/Home'));
const Vyhledavani = React.lazy(() => import('./pages/Vyhledavani'));
const Znalec = React.lazy(() => import('./znalec/Znalec'));
const Tlumocnik = React.lazy(() => import('./tlumocnik/Tlumocnik'));
const Authenticate = React.lazy(() => import('./pages/Authenticate'));
const Nastaveni = React.lazy(() => import('./pages/Nastaveni'));
const Zasobnik = React.lazy(() => import('./pages/Zasobnik'));
const EvidencePosudku = React.lazy(() => import('./pages/EvidencePosudku'));
const EvidenceUkonu = React.lazy(() => import('./pages/EvidenceUkonu'));
const ElektronickaZadost = React.lazy(() => import('./pages/ElektronickaZadost/ElektronickaZadost'));

const App = (): JSX.Element => {
  const { disableAuth, posudkyUrl, ukonyUrl, zadostiUrl, zasobnikUrl, pubWeb } = useConfig();
  const auth = useAuthorization();
  const token = useToken();
  const mainContentRef = useRef<HTMLDivElement>(null);
  const mainMenuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (window.location.href.indexOf('samlsignin') === -1) {
      token.refresh();

      if (token.getDataFromToken()) {
        // console.log('APP - refresh tick START');
        const tokenData = token.getDataFromToken();
        const expirationInterval = (tokenData.exp - tokenData.iat) * 1000;
        const interval = setInterval(() => {
          token.refresh();
        }, expirationInterval - 60000); // žádáme o nový jwt token minutu před jeho vypršením
        return () => clearInterval(interval);
      }
    }
    return;
  }, []);

  useEffect(() => {
    auth?.set(token?.value);
    if (window.location.href.indexOf('samlsignin') === -1) {
      if (!disableAuth && !token.value) {
        if (pubWeb) window.open(pubWeb, '_self');
        else token.redirectLogin();
      }
    }
  }, []);

  const getPageLogged = (defPage: any) => {
    if (disableAuth || token.value) {
      return defPage;
    }
    return Vyhledavani;
  };

  const jumpToContent = () => {
    if (mainContentRef.current) mainContentRef.current.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  };

  const jumpToMenu = () => {
    if (mainMenuRef.current) mainMenuRef.current.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  };

  return (
    <Layout jumpToMenu={jumpToMenu}>
      <MainMenu jumpToContent={jumpToContent} mainMenuRef={mainMenuRef} />
      <div role="main" id="main" ref={mainContentRef}>
        <Suspense fallback={<Loader />}>
          <Switch>
            <Route exact={true} path="/healthcheck">
              Status:OK
            </Route>
            <Route exact={true} path="/" component={getPageLogged(Home)} />
            <Route path="/samlsignin" component={Authenticate} />
            {/* {token.value ? (
            <> */}
            <Route path="/znalec/vysledky" component={Znalec} />
            <Route path="/znalec/detail" component={Znalec} />
            <Route path="/znalec" component={getPageLogged(Znalec)} />
            <Route path="/tlumocnik/vysledky" component={Tlumocnik} />
            <Route path="/tlumocnik/detail" component={Tlumocnik} />
            <Route path="/tlumocnik" component={getPageLogged(Tlumocnik)} />
            <Route exact={true} path="/vyhledavani" component={Vyhledavani} />
            <Route path="/nastaveni" component={getPageLogged(Nastaveni)} />
            {!zasobnikUrl?.endsWith('undefined') && <Route path="/zasobnik-prace" component={getPageLogged(Zasobnik)} />}
            {!posudkyUrl?.endsWith('undefined') && <Route path="/evidence-posudku" component={getPageLogged(EvidencePosudku)} />}
            <Route path="/osobni-udaje-a-cookies" component={OsobniUdajePage} />
            <Route path="/prohlaseni-o-pristupnosti" component={PristupnostPage} />
            <Route path="/napoveda" component={NapovedaPage} />
            {!ukonyUrl?.endsWith('undefined') && <Route path="/evidence-ukonu" component={getPageLogged(EvidenceUkonu)} />}
            {!zadostiUrl?.endsWith('undefined') && <Route path="/elektronicka-zadost" component={ElektronickaZadost} />}
            <Route path="/opendata" component={OpenDataPage} />
            {/* </>
            ) : (
              <ErrorPage status="401" />
            )} */}
            <Route path="*" render={() => <ErrorPage status="404" />} />
          </Switch>
        </Suspense>
      </div>
    </Layout>
  );
};

export default App;
